import React from 'react';
import PropTypes from 'prop-types';
import { Table, Header } from 'semantic-ui-react';
import { formatCurrencyRupiah } from 'utils/currencyUtils';
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner';

const BasePackageTable = ({ packages, isLoading }) => {
  const renderTableContent = () => {
    if (isLoading) {
      return (
        <Table.Row>
          <Table.Cell colSpan="3">
            <LoadingSpinner />
          </Table.Cell>
        </Table.Row>
      );
    }

    if (packages.length === 0) {
      return (
        <Table.Row>
          <Table.Cell colSpan="3" style={{ textAlign: 'center' }}>
            No data
          </Table.Cell>
        </Table.Row>
      );
    }

    return packages.map(pkg => (
      <Table.Row key={pkg.id}>
        <Table.Cell>{pkg.name}</Table.Cell>
        <Table.Cell>{formatCurrencyRupiah(pkg.price_per_month)}</Table.Cell>
      </Table.Row>
    ));
  };

  return (
    <div style={{ marginTop: '2em' }}>
      <Header as="h3">Base Billing Package</Header>
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Base Package Name</Table.HeaderCell>
            <Table.HeaderCell>Price</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>{renderTableContent()}</Table.Body>
      </Table>
    </div>
  );
};

BasePackageTable.propTypes = {
  packages: PropTypes.array,
  isLoading: PropTypes.bool,
};

BasePackageTable.defaultProps = {
  packages: [],
  isLoading: false,
};

export default BasePackageTable;
